export default "__VITE_ASSET__CTR1cz38__"